import { StreakIndicator } from '../../../containers/Streak/StreakIndicator';
import * as React from 'react';
import { useState } from 'react';
import analytics from '../../../shared/services/analytics/analytics';
import { getLocalStorageItem, setLocalStorageItem } from '../../../shared/helpers/local-storage';
import moment from 'moment/moment';
import { defaultDateTimeFormat } from '../../../shared/helpers';

interface StreakBarProps {
  userId: string;
}

export function StreakBar({ userId }: StreakBarProps) {
  const streakIndicatorCloseDateKey = 'streakIndicatorCloseDate';
  const isStreakIndicatorShownInitially = getIsStreakIndicatorShownInitially(userId, streakIndicatorCloseDateKey);

  const [isStreakBarShow, setIsStreakBarShown] = useState(isStreakIndicatorShownInitially);
  const handleHideStreakBar = () => {
    setIsStreakBarShown(false);
    analytics.trackCustomEvent('sim_click_close_streak_bar');
    setLocalStorageItem(userId, streakIndicatorCloseDateKey, moment.tz('est').format(defaultDateTimeFormat));
  };

  return (
    <>
      {isStreakBarShow && (
        <div className="editor-code__streak-indicator-bar">
          <div></div>
          <StreakIndicator />

          <div className="flash-messages__close" onClick={handleHideStreakBar} />
        </div>
      )}
    </>
  );
}

function getIsStreakIndicatorShownInitially(userId: string, streakIndicatorCloseDateKey: string) {
  const storedCloseDate = getLocalStorageItem(userId, streakIndicatorCloseDateKey);
  if (!storedCloseDate) {
    return true;
  }
  const parsedDate = moment(storedCloseDate, defaultDateTimeFormat);
  if (!parsedDate.isValid()) {
    return true;
  }
  const startOfTheDayEst = moment.tz('est').startOf('day');

  return parsedDate.isSameOrBefore(startOfTheDayEst);
}
